import { GcpBox, GcpDateRangeRecurring, GcpTypography } from '@back-office/ui';
import { Button, Dialog, Divider, IconButton } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseIcon from '@material-ui/icons/Close';
import { DateRange } from '@material-ui/pickers';
import { observer } from 'mobx-react';
import React, { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import useViewModel from './viewmodel';

const useStyles = makeStyles((theme) => ({
  icon: {
    fill: theme.palette.common.mineShaft,
  },
  button: {
    boxShadow: 'none',
  },
  disabledButton: {
    boxShadow: 'none',
    '&.Mui-disabled': {
      backgroundColor: '#F5F5F5 !important',
      color: '#00000040 !important',
      border: '1px solid #00000040 !important',
    },
  },
  headerSection: {
    height: '55px',
    '& > h3': {
      color: '#333',
      lineHeight: '24px',
      fontSize: '16px',
    },
  },
}));

export interface Store {
  date: DateRange<Date>;
  openCalendar: boolean;
  handleOnChangeDatePicker: (date: DateRange<Date>) => void;
  handleOnClickDatePicker: () => void;
  handleOnCloseDatePicker: () => void;
  handleOnClear: (event: MouseEvent<HTMLOrSVGElement>) => void;
  handleOnExport: () => void;
  handleClose: (event: MouseEvent<HTMLOrSVGElement>, reason: string) => void;
}

interface ExportToCsvDialogProps {
  open: boolean;
  handleOnClose: () => void;
}

const ExportToXLSXDialog: FC<ExportToCsvDialogProps> = observer((props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { open, handleOnClose } = props;
  const { state } = useViewModel(handleOnClose);

  return (
    <Dialog
      fullWidth
      aria-labelledby="export-to-csv-dialog"
      maxWidth="xs"
      open={open}
      onClose={state.handleClose}
    >
      <GcpBox
        alignItems="center"
        className={classes.headerSection}
        display="flex"
        justifyContent="space-between"
        ml={3}
      >
        <GcpTypography variant="h3">
          {t('biller_enrollment_list.export.title')}
        </GcpTypography>
        <IconButton aria-label="Close" onClick={state.handleOnClear}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      </GcpBox>
      <Divider />
      <GcpBox mb={3} ml={3} mr={3} mt={3}>
        <GcpBox>
          <GcpTypography
            paint="mineShaft"
            size={14}
            variant="body1"
            weight={500}
          >
            {t('biller_enrollment_list.export.select_date')}
          </GcpTypography>
        </GcpBox>
        <GcpBox mt={1}>
          <GcpDateRangeRecurring
            date={state.date}
            handleOnChange={state.handleOnChangeDatePicker}
            handleOnClear={state.handleOnClear}
            handleOnClick={state.handleOnClickDatePicker}
            handleOnClose={state.handleOnCloseDatePicker}
            openCalendar={state.openCalendar}
          />
        </GcpBox>
      </GcpBox>
      <Divider />
      <GcpBox
        display="flex"
        justifyContent="flex-end"
        mb={1}
        ml={3}
        mr={3}
        mt={1}
      >
        <Button
          className={classes.disabledButton}
          color="primary"
          disabled={!state.date[0] || !state.date[1]}
          size="large"
          type="button"
          variant="contained"
          onClick={state.handleOnExport}
        >
          {t('biller_enrollment_list.export.export')}
        </Button>
      </GcpBox>
    </Dialog>
  );
});

export default ExportToXLSXDialog;
